import React from 'react';
import { Link } from 'react-router-dom';
import { FaTwitter, FaLinkedinIn, FaFacebookF } from 'react-icons/fa';
import { useAuth } from '../../context/AuthContext';
import './Footer.css';

const Footer = () => {
  const { isLoggedIn } = useAuth();
  const requireAuth = (path) => (isLoggedIn ? path : '/login');

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-column footer-brand">
          <h3 className="footer-brand-title">UlsaApp</h3>
          <p>Universal Learning & Skill-development Platform</p>
          <p>Bridging knowledge and careers.</p>
          <p>Empowering access to learning for all.</p>
        </div>
        <div className="footer-column">
          <h3>Explore</h3>
          <ul>
            <li><Link to={requireAuth('/category/all-courses/all-courses')}>All Courses</Link></li>
            <li><Link to={requireAuth('/category/all-courses/all-courses?search=free')}>Free Courses</Link></li>
            <li><Link to={requireAuth('/faqs')}>FAQs</Link></li>
          </ul>
        </div>
        <div className="footer-column">
          <h3>Company</h3>
          <ul>
            <li><Link to={requireAuth('/about')}>About</Link></li>
            <li><Link to={requireAuth('/users-feedback')}>Feedback</Link></li>
            {/* <li><Link to={requireAuth("/terms")}>Terms of Service</Link></li> */}
            <li><Link to="/privacy">Privacy Policy</Link></li>
            <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
          </ul>
        </div>
        <div className="footer-column">
          <h3>Contact</h3>
          <p><a href="mailto:support.ulsaapp@atozasindia.in">support.ulsaapp@atozasindia.in</a></p>
          {/* <p><a href="tel:+911234567890">+91 12345 67890</a></p> */}
          <div className="footer-social">
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="footer-social-btn"><FaTwitter /></a>
            <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="footer-social-btn"><FaLinkedinIn /></a>
            <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="footer-social-btn"><FaFacebookF /></a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} UlsaApp. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;